var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:("odr-message odr-message_large odr-message_color-" + _vm.color + " " + (_vm.withClose ? 'odr-message_large_with-close' : ''))},[_c('tpl',{attrs:{"content":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }